module.exports = __webpack_public_path__ + "static/media/philbox-img02.ff382b08.jpg";